// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__3wO_T","a":"Loading_a__3imw5"};